import Link, { type LinkProps } from 'next/link';
import { forwardRef } from 'react';
import { parseCustomUserAgent } from './mobile';

type SafeLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  LinkProps & {
    target?: '_self' | '_blank' | '_parent' | '_top';
  };

const SafeLink = forwardRef<HTMLAnchorElement, SafeLinkProps>(
  ({ target = '_self', href, ...props }, ref) => {
    const mobileapp = parseCustomUserAgent()?.mobile_ios;

    if (!mobileapp && href) {
      return (
        <Link href={href} passHref {...props}>
          {props.children}
        </Link>
      );
    }

    return <a ref={ref} target={target} href={href} {...props} />;
  },
);

export default SafeLink;
